export default `
<div>
  <div class="grid w890">
    <h2>Followers</h2>
    <div class="user-list">
      <user-list-item user="user" ng-repeat="user in followers.feedItems" ></user-list-item>
    </div>
    <ut-load-more (load-more)="followers.loadMore()" [is-loading]="followers.isLoading" [is-last-page]="followers.isLastPage"></ut-load-more>
  </div>
</div>
`;
